import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "../../../styles/Components/integration/portfolio/PortfolioTable.module.css";
import { Table, Tooltip } from "antd";
import { formatAmount, formatPrice } from "../../../utility/helper";
import moment from "moment";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { getRelativeTime } from "../../../utility/formatter-helper";
import ExchangeHistoryTableExpandedRow from "./ExchangeHistoryTableExpandedRow";
import TradeButton from "../../../shared/trade-form/TradeButton";
import EmptyBox from "../../../ui/EmptyBox";

function ExchangeHistoryTable({ data, loading, exchange, error }) {
  const [tableData, setTableData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const sortedHistory = data?.sort((a, b) =>
    moment(b?.create_date, "YYYY-MM-DD HH:mm:ss.SSSSSS").diff(
      moment(a?.create_date, "YYYY-MM-DD HH:mm:ss.SSSSSS"),
    ),
  );

  const onRowClick = (record) => {
    if (expandedRowKeys.includes(record.key)) {
      setExpandedRowKeys([]);
      return;
    }
    setExpandedRowKeys([record.key]);
  };

  const dispatch = useDispatch();

  const columns = [
    {
      title: <span className={styles.title}>Asset</span>,
      dataIndex: "asset",
      key: "asset",
      align: "center",
      width: 60,
      render: (text) => (
        <span className={styles.tableContent}>
          <img
            src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${text}.png`}
            alt={text}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholders/exchange-logo.svg";
            }}
            className={styles.coinIcon}
          />
          {text}
        </span>
      ),
    },
    {
      title: <span className={styles.title}>Currency</span>,
      dataIndex: "currency",
      key: "currency",
      width: 55,
      responsive: ["lg"],
      align: "center",
      render: (text) => (
        <span className={`${styles.tableContent}`}>{text || "-"}</span>
      ),
    },
    {
      title: <span className={styles.title}>Amount</span>,
      dataIndex: "amount",
      key: "amount",
      width: 60,
      responsive: ["lg"],
      align: "center",
      render: (text) => (
        <span
          // onClick={() => clickHandler(text)}
          className={`${styles.tableContent}`}
        >
          {formatAmount(text)}
        </span>
      ),
    },
    {
      title: <span className={styles.title}>Action</span>,
      dataIndex: "action",
      key: "action",
      width: 60,
      responsive: ["xs", "sm"],
      align: "center",
      render: (text, record) => (
        <>
          <TradeButton
            btnClassName={`${styles.tableContent} ${
              text === "Buy" ? styles.buyBtn : styles.sellBtn
            }`}
            data={{ coin: record?.asset }}
          >
            {text}
          </TradeButton>
        </>
      ),
    },
    {
      title: <span className={styles.title}>Order Mode</span>,
      dataIndex: "orderMode",
      key: "orderMode",
      width: 85,
      responsive: ["md"],
      align: "center",
      render: (text) => <span>{text}</span>,
    },
    {
      title: <span className={styles.title}>Trigger Price</span>,
      dataIndex: "price",
      key: "price",
      width: 85,
      responsive: ["lg"],
      align: "center",
      render: (text) => (
        <span
          // onClick={() => clickHandler(text)}
          className={`${styles.tableContent}`}
        >
          {parseFloat(text) ? formatPrice(text) : text}
        </span>
      ),
    },
    {
      title: <span className={styles.title}>Date</span>,
      dataIndex: "date",
      key: "date",
      width: 85,
      responsive: ["xs", "sm"],
      align: "center",
      render: (text) => (
        <span
          // onClick={() => clickHandler(text)}
          className={`${styles.tableContent}`}
        >
          {getRelativeTime(text)}
        </span>
      ),
    },
    {
      title: <span className={styles.title}>Trader</span>,
      dataIndex: "trader",
      key: "trader",
      width: 85,
      align: "center",
      render: (text) => (
        <span
          // onClick={() => clickHandler(text)}
          className={`${styles.tableContent}`}
        >
          {text.replace("_", " ")}
        </span>
      ),
    },
    {
      title: (
        <span className={styles.title}>
          {window.innerWidth > 768 ? "Trade Status" : "Status"}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      width: 85,
      responsive: ["md"],
      align: "center",
      render: (text, record) => (
        <span
          // onClick={() => clickHandler(text)}
          className={`${styles.tableContent} ${styles.status}`}
        >
          <Tooltip
            title={record?.info?.order_message}
            color={
              record?.info?.order_message?.toLowerCase().includes("success")
                ? "green"
                : "red"
            }
          >
            {text}
            <IoMdInformationCircleOutline />
          </Tooltip>
        </span>
      ),
    },
  ];

  useEffect(() => {
    setTableData(
      sortedHistory?.map((item, index) => {
        return {
          key: index,
          asset: item?.asset_id,
          currency: item?.currency,
          amount: item?.amount,
          action: item?.trade_type,
          price: item?.trigger_price,
          date: item?.create_date,
          orderMode: item?.order_mode,
          trader: item?.trader,
          status: item?.trade_status,
          info: item,
        };
      }),
    );
  }, [data]);
  return (
    <div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableData}
        height={400}
        scroll={{ y: 400 }}
        className={`${styles.portfolioTable} expanded-table`}
        pagination={false}
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        expandable={{
          expandedRowRender: (record) => (
            <ExchangeHistoryTableExpandedRow data={record} />
          ),
          expandedRowKeys,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <IoChevronUp
                className={styles.expandIcon}
                onClick={(e) => {
                  onRowClick(record);
                }}
              />
            ) : (
              <IoChevronDown
                className={styles.expandIcon}
                onClick={(e) => {
                  onRowClick(record);
                }}
              />
            ),
          columnWidth: 10,
        }}
        locale={{
          emptyText: loading ? (
            "Loading orders history..."
          ) : (
            <div className={styles.noData}>
              <EmptyBox useCase={error ? "error" : "table"} size={40} />
              <span>
                {error
                  ? "Failed to load orders history. Please try again."
                  : "You have no orders history to display."}
              </span>
            </div>
          ),
        }}
      />
    </div>
  );
}

export default ExchangeHistoryTable;
